import * as React from 'react';
export const capchaseSvg = React.forwardRef(function capchaseSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14 3.533c.533.334.866.867.866 1.467v6c0 .6-.333 1.2-.866 1.467L7.934 16v-4L1 16v-3c0-.6.333-1.2.866-1.467l6.01-3.5-6.01-3.5C1.333 4.2 1 3.666 1 3.066V0l6.934 4V0L14 3.533ZM7.934 12l6.875-3.967-6.875-3.967V12Z',
    }),
  );
});
capchaseSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var capchase = {
  category: 'paymentmethod',
  colorable: true,
  name: 'capchase',
  svg: capchaseSvg,
};
